import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { Check, Map } from "lucide-react";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import { getCities } from "../../actions/userActions/cityAction";
import { getTerritories } from "../../actions/userActions/territoryAction";
import { addVisitProfile, getVisitProfileDetail, updateVisitProfile } from "../../actions/userActions/VisitProfileAction";
import VisitlocationsRow from "./VisitlocationsRow";
import "./AddVisitprofile.css";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_SEARCH,
} from '../../Constatns';
import AddButton from "../subComponents/buttons/CustomAddButton";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import TextField from "../designSystem/TextField";
import SingleSelect from "../designSystem/SingleSelect";
import { validateFields } from "../../utils/Validations";
import { getEmployee } from "../../actions/userActions/employeeAction";
import { PERMISSIONS } from "../../Permissions";
import BackNavHeader  from "../subComponents/BreadCrumbs/BackNavHeader ";

import AddNewForm from "../addNew/AddNewForm";
import AddNewDrawer from "../addNew/AddNewDrawer";
import AddTerritory from "../territories/AddTerritory";
import cityicon from "../../assets/images/cityIcon (2).svg";
import VisitProfileModal from "../planner/VisitProfileModal";

import { t } from "../../locales/translate";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const fetchedVisitProfileCities = new Set();
const fetchedTerritoryCities = new Set();

const fetchVisitProfileDetailForCityOnce = (dispatch, cityId) => {
  if (!cityId || fetchedVisitProfileCities.has(String(cityId))) return;
  fetchedVisitProfileCities.add(String(cityId));
  dispatch(getVisitProfileDetail({ cityId }));
};

const fetchTerritoriesForCityOnce = (dispatch, cityId) => {
  if (!cityId || fetchedTerritoryCities.has(String(cityId))) return;
  fetchedTerritoryCities.add(String(cityId));
  dispatch(getTerritories(-1, 0, cityId, undefined, ""));
};

const AddVisitProfile = () => {
  const TERRITORY_ENABLED = false; 
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const allCities = useSelector((state) => state.cities_reducer.cities);
  const territoriesData = useSelector((state) => state.territory_reducer.territories);
  const isTerritoriesLoading = useSelector((state) => state.territory_reducer.isTerritoryLoading);
  const addProfileStatus = useSelector((state) => state.visitProfile_reducer.addVisitProfile);
  const updateProfileStatus = useSelector((state) => state.visitProfile_reducer.updateVisitProfile);
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const visitProfileData = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
  const isVisitProfileDataLoading = visitProfileData === "isLoading";
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.result[0]?.user?.id;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [systemGeneratedName, setSystemGeneratedName] = useState("");
  const [canonicalTerritory, setCanonicalTerritory] = useState(null);
  const employeeData = useSelector((state) => state.employees_reducer.employee);

  const historyVisitProfileRow = location.visitProfile?.row;
  const initialFormValues = historyVisitProfileRow
    ? {
        visitProfileId: historyVisitProfileRow.visitProfileId || 0,
        name: historyVisitProfileRow.profileName || "",
        city: historyVisitProfileRow.cityId || "",
        territory: historyVisitProfileRow.territoryId || historyVisitProfileRow.territory || "",
        rows: (historyVisitProfileRow.visitLocations || []).map((loc) => ({
          visitLocationId: loc.visitLocationId || 0,
          practiceLocation: loc.practiceLocationId || "",
          doctors: Array.isArray(loc.doctorIds) ? loc.doctorIds : [],
        })),
      }
    : {
        visitProfileId: 0,
        name: "",
        city: "",
        territory: "",
        rows: [{ visitLocationId: 0, practiceLocation: "", doctors: [] }],
      };

  const initialValues = initialFormValues; 
   const VISIT_PROFILE_STATE_KEY = 'visitProfileState';
  const VISIT_PROFILE_ADD_STATE_KEY = 'visitProfileAddState';
   const VISIT_PROFILE_PATH = '/admin/visitProfiles';
  const [formValues, setFormValues] = useState(() => initialValues);
  const [formErrors, setFormErrors] = useState({});
   const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [assignToMe, setAssignToMe] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(() => !!historyVisitProfileRow);
  const [territoryChangePrompt, setTerritoryChangePrompt] = useState({
    open: false,
    territoryId: "",
  });
  useEffect(() => {
    dispatch(getEmployee(userId));
  }, [dispatch, userId]);
useEffect(() => {
  const saveState = () => {
      if (location.state?.fromVisitProfile || location.visitProfile) {
          sessionStorage.setItem(VISIT_PROFILE_STATE_KEY, JSON.stringify({
              page: location.state?.page || DEFAULT_PAGE,
              search: location.state?.search || DEFAULT_SEARCH,
              pageSize: location.state?.pageSize || DEFAULT_PAGE_SIZE
          }));
      }
  };
  
  window.addEventListener('beforeunload', saveState);
  
  if (!location.state?.fromVisitProfile && !location.visitProfile && sessionStorage.getItem(VISIT_PROFILE_STATE_KEY)) {
      try {
          const saved = JSON.parse(sessionStorage.getItem(VISIT_PROFILE_STATE_KEY));
          history.replace({
              ...location,
              state: {
                  fromVisitProfile: true,
                  page: saved.page,
                  search: saved.search,
                  pageSize: saved.pageSize
              }
          });
      } catch (e) {
          console.error("Error restoring state", e);
      }
  }
  
  return () => window.removeEventListener('beforeunload', saveState);
}, [location, history]);

// In the second useEffect
useEffect(() => {
  if (location.state && location.state.fromVisitProfile) {
      sessionStorage.setItem(VISIT_PROFILE_ADD_STATE_KEY, JSON.stringify({
          page: location.state.page || DEFAULT_PAGE,
          search: location.state.search || DEFAULT_SEARCH,
          pageSize: location.state.pageSize || DEFAULT_PAGE_SIZE
      }));
  }
}, [location.state]);

const navigateBack = () => {
  let page = DEFAULT_PAGE;
  let search = DEFAULT_SEARCH;
  let pageSize = DEFAULT_PAGE_SIZE;
  
  if (location.state && location.state.fromVisitProfile) {
      page = parseInt(location.state.page) || DEFAULT_PAGE;
      search = location.state.search || DEFAULT_SEARCH;
      pageSize = parseInt(location.state.pageSize) || DEFAULT_PAGE_SIZE;
  } else {
      try {
          const savedState = sessionStorage.getItem(VISIT_PROFILE_ADD_STATE_KEY);
          if (savedState) {
              const parsedState = JSON.parse(savedState);
              page = parseInt(parsedState.page) || DEFAULT_PAGE;
              search = parsedState.search || DEFAULT_SEARCH;
              pageSize = parseInt(parsedState.pageSize) || DEFAULT_PAGE_SIZE;
          }
      } catch (e) {
          console.error("Error retrieving state", e);
      }
  }

  const searchParams = new URLSearchParams();
  searchParams.set('page', page);
  searchParams.set('pageSize', pageSize);
  if (search) searchParams.set('search', search);
  
  history.push({
      pathname: VISIT_PROFILE_PATH,
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      state: {
          returnToVisitProfile: true,
          page,
          search,
          pageSize
      }
  });
};
  useEffect(() => {
  if (location.visitProfile) {
    const profileRow = location.visitProfile.row;
    setIsUpdateMode(true);
    setAssignToMe(false);

    setSystemGeneratedName(
      typeof profileRow.systemGeneratedName === "string" ? profileRow.systemGeneratedName : ""
    );
    if (profileRow.territoryId) {
      setCanonicalTerritory({ id: profileRow.territoryId, name: profileRow.territoryName || "" });
    }
    if (profileRow.cityId) {
      fetchVisitProfileDetailForCityOnce(dispatch, profileRow.cityId);
      fetchTerritoriesForCityOnce(dispatch, profileRow.cityId);
    }
  } else {
    setIsUpdateMode(false);
    setAssignToMe(false);
    setSystemGeneratedName(
      typeof employeeData?.systemGeneratedProfileName === "string"
        ? employeeData.systemGeneratedProfileName
        : ""
    );
  }
}, [location.visitProfile, employeeData, userId]);

// If territories data loads and we don't have a canonicalTerritory set, try to resolve it
useEffect(() => {
  if (
    !canonicalTerritory &&
    formValues.territory &&
    territoriesData &&
    territoriesData !== "isLoading" &&
    Array.isArray(territoriesData.result)
  ) {
    const found = territoriesData.result.find(
      (t) => String(t.id) === String(formValues.territory)
    );
    if (found) {
      setCanonicalTerritory({ id: found.id, name: found.name || "" });
    }
  }
}, [territoriesData, formValues.territory, canonicalTerritory]);

  useEffect(() => {
    dispatch(getCities({ filter: { countryId: "1" }, pageNumber: -1, pageSize: 0 }));
  }, [dispatch]);
  useEffect(() => {
    if (formValues.city) {
      if (historyVisitProfileRow) return;
      fetchVisitProfileDetailForCityOnce(dispatch, formValues.city);
      fetchTerritoriesForCityOnce(dispatch, formValues.city);
    }
  }, [dispatch, formValues.city, historyVisitProfileRow]);
const getOptions = () => {
   return (
      allCities !== "isLoading" &&
      allCities.length !== 0 &&
      allCities?.result.length !== 0 &&
      allCities?.result
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((city) => ({
          value: city.id,
          label: city.name
        }))
    ) || [];
};

const getTerritoryOptions = () => {
  if (territoriesData === "isLoading") return [];
  const list = (territoriesData?.result || [])
    .filter((territory) => territory?.isActive)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((territory) => ({ value: territory.id, label: territory.name }));

  if (canonicalTerritory && !list.some((o) => String(o.value) === String(canonicalTerritory.id))) {
    list.unshift({ value: canonicalTerritory.id, label: canonicalTerritory.name || "(Territory)" });
  }

  return list;
};

const selectedTerritoryPracticeLocationIds = (() => {
  if (!formValues.territory || !territoriesData?.result?.length) {
    return [];
  }

  const selectedTerritory = territoriesData.result.find(
    (territory) => String(territory.id) === String(formValues.territory)
  );

  return (selectedTerritory?.practiceLocations || []).map(
    (practiceLocation) => practiceLocation.practiceLocationId
  );
})();

const getUpdatedRowsForTerritory = (rows, territoryId) => {
  const selectedTerritory = territoriesData?.result?.find(
    (territory) => String(territory.id) === String(territoryId)
  );
  const allowedPracticeLocationIds = new Set(
    (selectedTerritory?.practiceLocations || []).map((practiceLocation) =>
      String(practiceLocation.practiceLocationId)
    )
  );

  return rows.map((row) => {
    if (!row.practiceLocation) {
      return row;
    }

    if (!selectedTerritory || allowedPracticeLocationIds.has(String(row.practiceLocation))) {
      return row;
    }

    return {
      ...row,
      practiceLocation: "",
      doctors: [],
    };
  });
};

const applyTerritoryChange = (territoryId) => {
  setFormValues((prevState) => ({
    ...prevState,
    territory: territoryId,
    rows: getUpdatedRowsForTerritory(prevState.rows, territoryId),
  }));
  setFormErrors((prevErrors) => ({
    ...prevErrors,
    territory: undefined,
  }));
};

  // Form value handlers
  const handleChange = (name, value) => {
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};

  const handleTextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleCityChange = (event) => {
    const selectedCityId = event.value;

    setFormValues((prevState) => ({
      ...prevState,
      city: selectedCityId,
      territory: "",
    }));

    setCanonicalTerritory(null);

    if (selectedCityId) {
      // Always refresh territories for the selected city so stale options are cleared.
      dispatch(getTerritories(-1, 0, selectedCityId, undefined, ""));
    }
  };

  const handleTerritoryChange = (event) => {
    const selectedTerritoryId = event.value;
    const territoryRows = getUpdatedRowsForTerritory(formValues.rows, selectedTerritoryId);
    const hasInvalidPracticeLocation = territoryRows.some(
      (row, index) =>
        row.practiceLocation !== formValues.rows[index]?.practiceLocation
    );

    // In update mode, show confirmation only when changing territory would
    // invalidate existing practice locations AND the canonical territory
    // wasn't already provided by the backend. If `canonicalTerritory` exists
    // (prefilled from the visit profile row), skip the warning.
    if (isUpdateMode && hasInvalidPracticeLocation && !canonicalTerritory) {
      setTerritoryChangePrompt({
        open: true,
        territoryId: selectedTerritoryId,
      });
      return;
    }

    applyTerritoryChange(selectedTerritoryId);
  };

  const handleToggleChange = (checked) => {
  setAssignToMe(checked);
};

  // Row management
  const handleAddRow = () => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: [
        ...prevState.rows,
        { visitLocationId: 0, practiceLocation: "", doctors: [] },
      ],
    }));
  };

  const handleRemoveRow = (rowIndex) => {
    setFormValues((prevState) => ({
      ...prevState,
      rows: prevState.rows.filter((_, index) => index !== rowIndex),
    }));
  };
 
 const handleSubmit = (e) => {
  e?.preventDefault?.();
  const errors = validateFields(formValues, 'visitProfile');

  if (TERRITORY_ENABLED && !isUpdateMode && !formValues.territory) {
    errors.territory = "Territory required";
  }

  setFormErrors(errors);
  if (Object.keys(errors).length === 0) {
    setIsSubmitting(true);
    let action;
    if (location.visitProfile) {
      const base = {
        visitProfileId: formValues.visitProfileId,
        profileName: formValues.name,
        cityId: formValues.city,
        isAssignedToMe: isUpdateMode ? undefined : assignToMe,
        visitLocations: formValues.rows.map((row) => ({
          visitLocationId: row.visitLocationId,
          practiceLocationId: row.practiceLocation,
          doctorIds: row.doctors,
        })),
      };

      const visitProfileData = {
        ...base,
        ...(formValues.territory ? { territoryId: formValues.territory } : {}),
      };

      action = updateVisitProfile(visitProfileData);
    } else {
      const addPayload = {
        visitProfileId: 0,
        profileName: formValues.name,
        cityId: formValues.city,
        isAssignedToMe: assignToMe,
        visitLocations: formValues.rows.map((row) => ({
          visitLocationId: row.visitLocationId || 0,
          practiceLocationId: row.practiceLocation || 0,
          doctorIds: Array.isArray(row.doctors) ? row.doctors : [],
        })),
        territoryId: formValues.territory || 0,
      };
      action = addVisitProfile(addPayload);
    }
    dispatch(action)
      .then(() => {
        setIsSubmitting(false);
        navigateBack();
      })
      .catch(() => {
        setIsSubmitting(false);
      });
  }
};

 const handleGoBack = () => {
    navigateBack();
  };

  const handleContinueTerritoryChange = () => {
    applyTerritoryChange(territoryChangePrompt.territoryId);
    setTerritoryChangePrompt({ open: false, territoryId: "" });
  };

  const handleCancelTerritoryChange = () => {
    setTerritoryChangePrompt({ open: false, territoryId: "" });
  };

  return (
    <>
      {/* Redirects for completed operations or permission checks */}
      {addProfileStatus && addProfileStatus !== "isLoading" && <Redirect to="/admin/visitProfiles" />}
      {updateProfileStatus && updateProfileStatus !== "isLoading" && <Redirect to="/admin/visitProfiles" />}
      {!permissions.includes(PERMISSIONS.CAN_ADD_VISIT_PROFILE) &&
        !permissions.includes(PERMISSIONS.CAN_UPDATE_VISIT_PROFILE) && <Redirect to="/admin" />}
      {!location.id && <Redirect to={"/admin/AddVisitProfile"} />}
<div className="add-visit-profile-container" style={{ position: 'relative', minHeight: '100vh', borderRadius: '8px', overflow: 'hidden' }}>  
  <LoadingOverlay 
  isVisible={
    allCities === "isLoading" || 
    isSubmitting ||
    addProfileStatus === "isLoading" || 
    updateProfileStatus === "isLoading"
  }
/>
  <BackNavHeader text={location.visitProfile ? "Edit Visit Profile" : t("addVisitProfile")} onBack={handleGoBack} />
        <div className="add-content-wrapper">
          <div className="row" style={{ width: TERRITORY_ENABLED ? undefined : "136%" }}> 
            <div className="col-3">
              <TextField
                name="systemGeneratedName"
                label={t("name")}
                type="text"
                disabled
                value={systemGeneratedName}
                placeholder=""
              />
            </div>
            <div className="col-3">
              <TextField
                name="name"
                label= {`${t("displayName")} *`}
                type='text'
                value={formValues.name}
                onChange={handleTextChange}
                placeholder={t("displayName")}
                error={formErrors.name}
              />
            </div>
            <div className="col-3">
              <SingleSelect
                label= {`${t("city")} *`}
                isSearchable
                secondaryLabel
                iconEnd
                error={formErrors.city}
                disabled={!!location.visitProfile?.row.cityId}
                onChange={handleCityChange}
                value={formValues.city}
                placeholder={t("city")}
                options={getOptions()}
                configKey={"city"}
                onAddNewClick={() => handleAddNew("city")}
              />
            </div>
            {TERRITORY_ENABLED && (
            <div className="col-3">
              <SingleSelect
                label={isUpdateMode ? t("Territory") : `${t("Territory")} *`}
                isSearchable
                secondaryLabel
                iconEnd
                onChange={handleTerritoryChange}
                value={formValues.territory}
                placeholder={t("Territory")}
                options={getTerritoryOptions()}
                configKey={"territory"}
                onAddNewClick={() => handleAddNew("territory")}
                error={!isUpdateMode ? formErrors.territory : undefined}
                isLoading={!!formValues.city && isTerritoriesLoading}
              />
            </div>
            )}
          </div>

          <hr />

          <div className="add-visit-profile-row-container">
            {formValues.rows.map((row, index) => (
              <VisitlocationsRow
                key={index}
                row={row}
                index={index}
                formValues={formValues}
                selectedTerritoryId={formValues.territory}
                cityId={TERRITORY_ENABLED ? undefined : formValues.city}
                allowedPracticeLocationIds={TERRITORY_ENABLED ? selectedTerritoryPracticeLocationIds : []}
                visitProfileData={visitProfileData}
                isVisitProfileDataLoading={isVisitProfileDataLoading}
                isUpdateMode={isUpdateMode}
                formErrors={formErrors}
                setFormValues={setFormValues}
                setFormErrors={setFormErrors}
                handleRemoveRow={handleRemoveRow}
              />
            ))}
            <div className="add-visit-profile-form-actions-left">
              <AddButton
                onClick={handleAddRow}
                text={t("addAnother")}
              />
            </div>
          </div>

        <hr />

<div className={`add-visit-profile-form-actions ${!isUpdateMode ? 'has-toggle' : ''}`}>
  {!isUpdateMode && (
    <div className="form-toggle-row">
      <span className="form-toggle-label">{t("assignToMe")}</span>
      <div
        className={`toggle-switch ${assignToMe ? "toggle-on" : "toggle-off"}`}
        onClick={() => handleToggleChange(!assignToMe)}
        role="switch"
        aria-checked={assignToMe}
      >
        <div className="toggle-button" />
      </div>
    </div>
  )}
  
  <div className="button-group">
    <CancelButton onClick={handleGoBack} text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""}/>
    <PrimaryButton
      onClick={handleSubmit} 
      text={location.visitProfile ? `${t("update")}` : `${t("save")}` }
      icon={Check}
      width={location.visitProfile ? "95px" : document.body.dir === "rtl" ? "123px" : ""}
    />
  </div>
</div>
        </div>
      </div>
      <AddNewDrawer
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
            setDrawerLoading(false);
          }}
         title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          loading={drawerLoading}
          icon={
            drawerItem === "city" ? (
              <img src={cityicon} alt={drawerItem} />
            ) : drawerItem === "territory" ? (
              <div className="dynamicmodal-header-left">
                <div className="icon">
                  <Map size={20} strokeWidth={1.5} color="white" />
                </div>
              </div>
            ) : null
          }
        >
          {drawerItem === "territory" ? (
            <AddTerritory
              onClose={() => {
                setDrawerOpen(false);
                setDrawerLoading(false);
              }}
              onSave={() => {
                setDrawerOpen(false);
                setDrawerLoading(false);
              }}
              onLoadingChange={setDrawerLoading}
              isDrawerMode
            />
          ) : drawerItem ? (
            <AddNewForm
              itemName={drawerItem}
              onClose={() => {
                setDrawerOpen(false);
                setDrawerLoading(false);
              }}
              onLoadingChange={setDrawerLoading}
              onSave={(newCity) => {
                if (drawerItem === "city") {
                  dispatch(getCities({ filter: { countryId: "1" }, pageNumber: -1, pageSize: 0 })).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      city: newCity.id,
                    }));
                  });
                }
              }}
            />
          ) : null}
</AddNewDrawer>
      <VisitProfileModal
        isVisible={territoryChangePrompt.open}
        onClose={handleCancelTerritoryChange}
        onConfirm={handleContinueTerritoryChange}
        title="Update Territory"
        message="Some of the existing practice locations doesn't belong to the territory you selected. This change will discard the existing locations. Do you want to make these changes?"
        cancelText="Cancel"
        confirmText="Continue"
        confirmColor="#0438B4"
        containerWidth="401px"
      />
    </>
  );
};

export default AddVisitProfile;
